import React from "react";
import { bindActionCreators } from "redux";
import * as modalActions from "../../redux/actions/modalActions";
import { useSelector, useDispatch } from "react-redux";
import JobDetailModalComponent from "../../components/Std/JobDetailModal";
import PropTypes from "prop-types";

const JobDetailModal = (props, context) => {
  const dispatch = useDispatch();

  const modalAction = bindActionCreators(modalActions, dispatch);

  const closeRemoveModal = () => {
    modalAction.closeRemoveModal();
  };

  return (
    <JobDetailModalComponent
      closeRemoveModal={closeRemoveModal}
      {...props}
    />
  );
};
JobDetailModal.contextTypes = {
  t: PropTypes.func.isRequired,
};
export default JobDetailModal;
